// extracted by mini-css-extract-plugin
export default {"container":"jjJO6","text":"jaZjd","button":"zfJYZ"};